module.exports = __webpack_public_path__ + "static/media/ebube.4be25916.svg";